import { render, staticRenderFns } from "./UserCourseProgresses.vue?vue&type=template&id=947977ea&"
import script from "./UserCourseProgresses.vue?vue&type=script&lang=js&"
export * from "./UserCourseProgresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports